// src/config/auth.js

/**
 * AWS Cognito configuration for Amplify v6
 * Environment variables are set in .env (dev) and .env.production (prod)
 */
export const authConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT],
          responseType: 'code',
        },
      },
    },
  },
};

/**
 * Validate that all required environment variables are set
 * Returns true if valid, false if missing required vars
 */
export const validateAuthConfig = () => {
  const required = [
    'REACT_APP_COGNITO_USER_POOL_ID',
    'REACT_APP_COGNITO_CLIENT_ID',
    'REACT_APP_COGNITO_DOMAIN',
    'REACT_APP_REDIRECT_SIGN_IN',
    'REACT_APP_REDIRECT_SIGN_OUT',
  ];

  const missing = required.filter((key) => !process.env[key]);

  if (missing.length > 0) {
    console.warn(
      'Missing Cognito environment variables:',
      missing.join(', '),
      '\nAuthentication will be disabled. Copy .env.example to .env and configure.'
    );
    return false;
  }
  return true;
};

/**
 * Check if auth is properly configured
 */
export const isAuthConfigured = () => {
  return !!(
    process.env.REACT_APP_COGNITO_USER_POOL_ID &&
    process.env.REACT_APP_COGNITO_CLIENT_ID &&
    process.env.REACT_APP_COGNITO_DOMAIN
  );
};
